const info_counters: any = [
  {
    id: 0,
    count: 207,
    title: "Abunəçilər",
  },    
  {
    id: 1,
    count: 300,
    title: "İzləyicilər",
  },
  {
    id: 2,
    count: 67,
    title: "Abunəçilər",
  },
  {
    id: 3,
    count: 70,
    title: "Ümumi Postlar",
  },
];

export default info_counters;
